// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2JqUG","bigColWidth":"Table_bigColWidth__2Mzu_","biggerColWidth":"Table_biggerColWidth__1GRCg","row":"Table_row__1GjL5","col":"Table_col__2tluQ"};